<template>
    <div>
        Please select a notifier type
    </div>
</template>

<script>
export default {
    name: 'notificators-not-selected',
    data() {
        return {}
    },
}
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/notificators/NotSelected.vue